module.exports = __webpack_public_path__ + "img/verified.a93e5974.svg";